import React from 'react'

import { CurrentUser } from 'typings/currentUser'

export const CurrentUserContext = React.createContext<CurrentUser | undefined>(undefined)
